<template>
  <v-flex xs12 mt-1 mb-1 class="justify-center text-xs-center">
    <h1 class="app-title font-red animated fadeInRight">{{title}}</h1>
  </v-flex>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/helpers/variables";
.app-title {
  font-family: androgyne;
  border-top: solid 1px $primary-red;
  border-bottom: solid 1px $primary-red;
  font-weight: bold;
  font-size: 3rem;
  line-height: 3.3rem;
  text-align: center;
  max-width: 600px;
  margin: 20px auto;
}
@media (min-width: 600px) {
  .app-title {
    font-size: 4rem;
    line-height: 5rem;
  }
}
</style>




// WEBPACK FOOTER //
// Titlecen.vue?02e2d00d